@if (isMulti()) {
  <elcia-multi-dropdown [control]="control()"
                        [items]="users()"
                        [label]="labelKey() | translate"
                        [textField]="'fullName'"/>
} @else {
  <elcia-dropdown [control]="control()"
                  [items]="users()"
                  [label]="labelKey() | translate"
                  [textField]="'fullName'"/>
}
